import React, {Component} from "react";
import {Chip, TextField} from "@mui/material";
import {isEnterPressed} from "../../../utils/utils";

class CreateChip extends Component {

	constructor(props) {
		super(props);

		this.state = {
			clicked: false,
		}
	}

	onClick = () => this.setState({clicked: true});

	onCreate = (value) => {
		this.props.onCreate(value);
		this.setState({clicked: false});
	}

	render() {
		return this.state.clicked ?
			<TextField sx={this.props.sx} fullWidth placeholder={"Create"} color={"secondary"} variant={"filled"}
			           autoFocus={true} onKeyDown={e => isEnterPressed(e) && this.onCreate(e.target.value)}/> :
			<Chip label={this.props.label} size={"small"} onClick={this.onClick} variant={"outlined"}
			      color={"secondary"} sx={this.props.sx}/>
	}
}

export default CreateChip;
